/** Render a reference's sequence number as `REF003` (V1 ReferenceUtil.seqId parity). */
export function seqId(seq: number): string {
  return `REF${seq.toString().padStart(3, "0")}`;
}

/** Extract a bare Google Drive file id from a pasted `drive.google.com/file/d/<id>/...` URL. */
export function extractGoogleDriveFileId(input: string): string {
  const match = input.match(/https:\/\/drive\.google\.com\/file\/d\/(.*)\/.+/);
  return match ? match[1] : input;
}
